export const TAKE_TYPE = [
    {label: '快递收货', value: 'post'},
    // {label: '充值账号', value: 'account'},
    // {label: '充值手机号码', value: 'phone'},
    {label: '系统发放', value: 'system'},
    // {label: '线下领取', value: 'offline'},
]

export const NORMAL = 'normal'
export const UN_START = 'not_start'
export const ENDED = 'ended'

export const STATUS_OPTION = [
    {label: '未开始', value: UN_START, type: 'primary'},
    {label: '进行中', value: NORMAL, type: 'success'},
    {label: '已结束', value: ENDED, type: 'info'},
]


export const STATUS_DESC = (status) => {
    return STATUS_OPTION.find(item => item.value === status)?.label
}

export const STATUS_BADGE = (status) => {
    return STATUS_OPTION.find(item => item.value === status)?.type
}

export const GIFT_TYPE = Object.freeze({
    entity: 'entity',
    invented: 'invented',
    lemon_music_coupon: 'lemon_music_coupon',

    options() {
        return [
            {label: '实物礼品', value: this.entity, desc: '请选择礼品'},
            {label: '虚拟卡卷', value: this.invented, desc: '请选择礼品'},
            {label: '柠檬音乐券', value: this.lemon_music_coupon, desc: '请选择礼品'},

        ]
    },

    filterValue(value) {
        return this.options().find(op => op.value === value)?.label
    },

    entityTakeList: {
        entity: [{label: '快递收货', value: 'post'}],
        invented: [{label: '系统发放', value: 'system'}],
        lemon_music_coupon: [{label: '系统发放', value: 'system'}],
    }
})
